





























import Vue from "vue";
import { DynamicItem } from "../interfaces/ToolbarItem";
import ToolbarItem from "./ToolbarItem.vue";

export default Vue.extend({
  props: {
    menu: {
      type: Array as () => DynamicItem[],
    },
    delete: {
      type: Boolean,
      required: false,
    },
    limit: {
      type: Number,
      required: false,
    },
    config: {
      type: Object,
      required: false,
    },
  },
  components: { ToolbarItem },
  computed: {
    deletable(): boolean {
      return !!this.delete;
    },
    menuSlice(): DynamicItem[] {
      return this.menu.slice(this.limit + 1);
    },
  },
  methods: {
    handleDelete(link: DynamicItem) {
      return this.$emit("delete", link);
    },
  },
});
